import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { LoadingSpinner } from '../components/shared/LoadingSpinner';
import { sleep } from '../utils/utils';

/**
 * This component is the same as ExitIframe, except the URL comparison ( if(url.hostname === location.hostname) ).
 * @param props
 * @constructor
 */
export const RedirectOutsideIframe: React.FC = (props) => {
    const { search } = useLocation();

    const redirect = async () => {
        if (search) {
            const params = new URLSearchParams(search);
            const redirectUri = params.get('redirectUri');
            if (redirectUri) {
                const url = new URL(decodeURIComponent(redirectUri));

                /**
                 * Sometimes app bridge forgets to redirect. Putting in a wait seems to fix it.
                 */
                await sleep(1000);

                open(decodeURIComponent(redirectUri), '_top');
            }
        }
    };

    useEffect(() => {
        redirect();
    }, [search]);

    return <LoadingSpinner />;
};
